import { defineStore } from 'pinia';
import { SelfServiceService } from '@/services/store';
import { flatMap } from 'lodash-es';
import { IIncompleteClaim } from '@/interfaces';
import { ref } from 'vue';

export const useSelfServiceInsuranceClaims = defineStore('SelfServiceInsuranceClaims', () => {
  const incompleteClaims = ref<IIncompleteClaim[]>([]);

  const getIncompleteClaims = async (policyNumbers: string[]) => {
    const res: { incompleteClaimsByPolicyNumber: Record<string, IIncompleteClaim[]> } =
      await SelfServiceService.getIncompleteClaims(policyNumbers);
    incompleteClaims.value = flatMap(Object.values(res.incompleteClaimsByPolicyNumber));
    return incompleteClaims.value;
  };
  return {
    incompleteClaims,
    getIncompleteClaims,
  };
});
